import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=b8e4af5a&scoped=true&"
import script from "./BreadCrumb.vue?vue&type=script&lang=js&"
export * from "./BreadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=b8e4af5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e4af5a",
  null
  
)

export default component.exports